import { Modal } from "@circle-react-uikit/ModalV2";
import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";

import { PlansModalBody } from "./PlansModalBody";
import type { PlansModalProps } from "./PlansModalBody";

export const PlansModalUIKitComponent = (props: PlansModalProps) => {
  const modal = useModal();

  const handleOnClose = async () => {
    await modal.hide();
    modal.remove();
  };

  return (
    <Modal isOpen={modal.visible} onClose={handleOnClose}>
      <Modal.Overlay />
      <Modal.Content size="full">
        <Modal.Header className="!justify-end">
          <Modal.HeaderActions>
            <Modal.CloseButton onClick={handleOnClose} />
          </Modal.HeaderActions>
        </Modal.Header>
        <PlansModalBody {...props} />
      </Modal.Content>
    </Modal>
  );
};
